module.exports = __webpack_public_path__ + "static/media/vbn-picture-3.9ccafc56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-picture-3.jpg
// module id = 580
// module chunks = 0